module.exports = __webpack_public_path__ + "media/images/landings/promotion_2/solution_img_03-aec2080f116a5c512649fd30af98fc73.png";